<template>
  <div
    class="sticky"
    v-if="cartTotalStickySetting && cartTotalStickySetting.active"
  >
    <div :class="contentClass" class="d-flex justify-center content">
      <div class="build-version">{{ buildVersion }}</div>
      <div class="d-flex align-center" @click="goToCart">
        <h2 class="amount">
          <b>{{ $store.getters['theme/getIsCurrencyShownAtOrder'] ? $store.getters['theme/getCurrencySymbol'] : '' }}{{ formatPrice($store.getters["cart/grandTotal"]) }}</b>
        </h2>
        <v-badge 
        offset-x="10"
        offset-y="15" :color="cartTotalStickySetting.nodes.badge.data.attr.style.color" class="cart-badge" :content="$store.getters['cart/getTotalProduct']" :overlap="cartTotalStickySetting.nodes.badge.data.attr.overlap">
          <v-btn @click="goToCart" icon :x-large="cartTotalStickySetting.nodes.cartIcon.data.attr.xLarge">
            <v-icon class="icon-cart" />
          </v-btn>
        </v-badge>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import comminMixin from "../mixins/common";
import currentVersion from "../../version.json";
export default {
  mixins: [comminMixin],
  computed: {
    // Diagnostic stamp so a phone can be told apart from a cached bundle.
    // Built defensively: version.json is generated by scripts/bump.sh and a
    // checkout that has not run it only carries { version }, so hash/branch
    // must not be printed as the string "undefined".
    buildVersion() {
      const { version, hash } = currentVersion || {};
      const parts = [];
      // bump.sh parses the version out of package.json with awk and leaves a
      // leading space on it, so trim before rendering.
      if (version) parts.push(`v${String(version).trim()}`);
      if (hash) parts.push(String(hash).trim());
      return parts.join(" · ");
    },
    ...mapState({
      dbData: (state) => state.theme.data,
    }),
    cartTotalStickySetting() {
      return this.$store.getters["theme/general"].cartTotalSticky;
    },

    contentClass() {
      let classes = ['d-flex', 'content'];
      classes.push(this.cartTotalStickySetting.nodes.content.data.flexDirection);
      return classes;
    }
  },
  mounted() {
    this.applyCss();
  },

  watch: {
    cartTotalStickySetting: {
      handler(newValue) {
        this.applyCss();
      },
      deep: true,
    },
  },
  methods: {
    goToCart() {
      this.$router.push("/cart");
    },
    applyCss() {
      // BADGE
      document.body.style.setProperty(
        "--cartTotalSticky_BadgeColor",
        this.cartTotalStickySetting.nodes.badge.data.attr.style.color
      );
      document.body.style.setProperty(
        "--cartTotalSticky_BadgeBackgroundColor",
        this.cartTotalStickySetting.nodes.badge.data.attr.style.backgroundColor
      );
      document.body.style.setProperty(
        "--cartTotalSticky_BadgeFontSize",
        this.cartTotalStickySetting.nodes.badge.data.attr.style.fontSize
      );
      document.body.style.setProperty(
        "--cartTotalSticky_BadgeFontWeight",
        this.cartTotalStickySetting.nodes.badge.data.attr.style.fontWeight
      );

      // ICON
      document.body.style.setProperty(
        "--cartTotalSticky_CartIconColor",
        this.cartTotalStickySetting.nodes.cartIcon.data.attr.style.color
      );
      // AMOUNT
      document.body.style.setProperty(
        "--cartTotalSticky_AmountPadding",
        this.cartTotalStickySetting.nodes.amount.data.attr.style.padding
      );

      document.body.style.setProperty(
        "--cartTotalSticky_AmountColor",
        this.cartTotalStickySetting.nodes.amount.data.attr.style.color
      );

      document.body.style.setProperty(
        "--cartTotalSticky_AmountFontSize",
        this.cartTotalStickySetting.nodes.amount.data.attr.style.fontSize
      );

      // CONTENT
      document.body.style.setProperty(
        "--cartTotalSticky_ContentPadding",
        this.cartTotalStickySetting.nodes.content.data.attr.style.padding
      );
      document.body.style.setProperty(
        "--cartTotalSticky_ContentMargin",
        this.cartTotalStickySetting.nodes.content.data.attr.style.margin
      );

      document.body.style.setProperty(
        "--cartTotalSticky_ContentBackgroundColor",
        this.cartTotalStickySetting.nodes.content.data.attr.style.backgroundColor
      );
    },
  },
};
</script>

<style>
.sticky {
  width: 100vw;
  position: fixed;
  bottom: 0px;
  left: 0;
  z-index: 1;
  overflow: hidden;
}

.sticky .content {
  padding: var(--cartTotalSticky_ContentPadding, 5px);
  margin: var(--cartTotalSticky_ContentMargin, 0px);
  border-radius: 0px;
  border: 0px;
  background: var(--cartTotalSticky_ContentBackgroundColor, #cfcfcf);
}

.sticky .amount {
  font-size: var(--cartTotalSticky_AmountFontSize, 20px);
  color: var(--cartTotalSticky_AmountColor, #ffffff);
  padding: var(--cartTotalSticky_AmountPadding, 5px);
}

.sticky .build-version {
  align-self: center;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 11px;
  line-height: 1.2;
  letter-spacing: 0.02em;
  color: #ffffff;
  opacity: 0.65;
  pointer-events: none;
}

.sticky .icon-cart {
  background-color: var(--cartTotalSticky_CartIconColor, #000000);
  -webkit-mask: url(/asset/icons/grocery-store.svg) no-repeat center;
  mask: url(/asset/icons/grocery-store.svg) no-repeat center;
}

.sticky .cart-badge .v-badge__wrapper span {
  color: var(--cartTotalSticky_BadgeColor, #00FF00) !important;
  font-size: var(--cartTotalSticky_BadgeFontSize, 12px);
  font-weight:var(--cartTotalSticky_BadgeFontWeight, bold);
  background: var(--cartTotalSticky_BadgeBackgroundColor, #CFCFCf) !important;
}
</style>